import React from 'react';
import Navbar from './components/Navbar';


import './App.css';



function App() {
  return (
    
      <div>
      <Navbar/>
      
        
        
        
       
        </div>

    
  );
}

export default App;
